<div cdkDropList data-testid="waypoints-list-container" (cdkDropListDropped)="drop($event)" [hidden]="navigation">
  @for (routeEl of routeList; track routeEl; let i = $index) {
  <div class="search-el" [attr.data-testid]="'waypoints-item-' + i" cdkDrag>
    <div class="dnd-icon grab" [attr.data-testid]="'waypoints-drag-' + i" [ngClass]="{'inactive': !isDragAndDrop()}" cdkDragHandle>
      <img [src]="dragAndDropIconPath()" alt="drag and drop" />
    </div>
    @if (i==0) {
    <app-search [attr.data-testid]="'waypoints-search-' + i" (searchChanged)="waypointChangedHandler($event, i)" (keyPressed)="keyPressedHandler()"
      [inputValue]="routeEl.display_name"
      [routeIcon]="getRouteStartIcon(routeList[i])" id="route-search-start" [failedPlan]="(failedPlan && maxReachedWaypoint<i)">
    </app-search>
    }
    @if (i!=0 && i!=routeList.length-1) {
    <app-search [attr.data-testid]="'waypoints-search-' + i" (searchChanged)="waypointChangedHandler($event, i)" (keyPressed)="keyPressedHandler()"
      [inputValue]="routeEl.display_name"
      [routeIcon]="getRouteWaypointIcon(routeList[i])" [waypointIdx]="i" id="route-search-start"
      [failedPlan]="(failedPlan && maxReachedWaypoint<i)" [csid]="routeList[i].csid ?? ''">
    </app-search>
    }
    @if (i==routeList.length-1 && routeList.length!=1) {
    <app-search [attr.data-testid]="'waypoints-search-' + i" (searchChanged)="waypointChangedHandler($event, i)" (keyPressed)="keyPressedHandler()"
      [inputValue]="routeEl.display_name"
      [routeIcon]="getRouteEndpointIcon(routeList[i])" id="route-search-end"
      [failedPlan]="(failedPlan && maxReachedWaypoint<i)" [csid]="routeList[i].csid ?? ''">
    </app-search>
    }
    @if (i!=0) {
    <div class="dnd-icon" [attr.data-testid]="'waypoints-remove-' + i" (click)="deletePoint(i)"
      [matTooltip]="languageService.languageJSON.InfoSidebar_Tooltip_RemoveRoutePoint" matTooltipShowDelay="500"
      matTooltipClass="google-tooltip">
      <img class="delete" [src]="waypointRemoveIconPath()" alt="delete route point" />
    </div>
    }
    @if (i==0) {
    <div class="dnd-icon" [attr.data-testid]="'waypoints-locate-' + i" (click)="setStartCoordsToYourGeolocation()"
      [matTooltip]="languageService.languageJSON.InfoSidebar_Tooltip_SetToYourLocation" matTooltipShowDelay="500"
      matTooltipClass="google-tooltip">
      <img class="locate-icon" [src]="waypointSetToLocationIconPath()" alt="set to your location" />
    </div>
    }
  </div>
  }
</div>

@if (routeList.length>=5 && !navigation) {
<div class="silent-warning">{{
  languageService.languageJSON.InfoSidebar_WaypointLimitReached }}</div>
}

@if (!navigation && selectedDisplayMode==DisplayMode.ROUTE && routeList.length<5) {
<div id="add-waypoint-btn" class="waypoints-menu" data-testid="waypoints-add-container" [hidden]="mobileResolution && mobileVisibleRoutePanel!='routepoints'">
  <div class="navi-icon-outer">
    <div class="ev-button primary search-element-functions-icon" data-testid="waypoints-add-btn" (click)="addRoutePoint()"
      [ngClass]="{'grayscale': emptySearchInput || failedPlan}">
      <img src="assets/icons/dark/ui/addtrackpoint_icon.svg" />
    </div>
    <div class="ev-button primary search-element-functions-icon" data-testid="waypoints-add-home-btn" (click)="addHomeToRoutePoint()">
      <img src="assets/icons/dark/ui/home_icon.svg" alt="home" />
    </div>
    <div class="ev-button primary search-element-functions-icon" data-testid="waypoints-add-work-btn" (click)="addWorkToRoutePoint()">
      <img src="assets/icons/dark/ui/work_icon.svg" alt="home" />
    </div>
  </div>
</div>
}